module.exports = __webpack_public_path__ + "static/EverForward0-5ef8ad9252d48bee5f51de42de85fe20.webp";